import React from 'react';

const RefundInformation = (
  <>
    <p>To request a refund for <b>Prepaid Collect Call</b> accounts, please call 1-800-896-3201. </p>
    <p> For <b>Inmate Wallet – Voice and Video Calling Only</b> accounts, refunds will be issued to the most recent contributor(s), based on the remaining balance. To determine the available refund amount and verify eligibility, please call 1-800-896-3201 for assistance.</p>
  </>
)

export default RefundInformation;
